import Clients from './Clients/Clients';
import Admin from './Admin/Admin';
import Resellers from './Resellers/Resellers';


class OnlineShopConnectorApiSDK {
    settings = {
        endpoint: null,
        localization: 'nl_NL',
        auth: {
            token: null,
        },
    }

    constructor(endpoint, localization, token = false) {
        this.setEndpoint(endpoint);
        this.setLocalization(localization);
        this.setToken(token);

        this.clients = new Clients(this.settings);
        this.admin = new Admin(this.settings);
        this.resellers = new Resellers(this.settings);
    }

    setEndpoint(endpoint) {
        if (endpoint === undefined) {
            throw new Error('The endpoint is required to construct this SDK');
        }

        this.settings.endpoint = endpoint;
    }

    setLocalization(localization) {
        this.settings.localization = localization !== undefined ? localization : 'nl_NL';
    }

    setToken(token) {
        this.settings.auth.token = token !== false ? token : null;
    }
}

export default OnlineShopConnectorApiSDK;
